// src/components/Layout/MainLayout.js
import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Footer from "./Footer";
import { useAppContext } from "../../context/AppContext";
import {
  FileText,
  Settings,
  Code,
  FileUp,
  LayoutDashboard,
} from "lucide-react";

function MainLayout() {
  const { state, actions } = useAppContext();
  const { sidebarOpen } = state;
  const location = useLocation();

  // Close sidebar when route changes on mobile
  useEffect(() => {
    if (sidebarOpen && window.innerWidth < 1024) {
      actions.toggleSidebar();
    }
  }, [location.pathname]);

  const menuItems = [
    {
      title: "Dashboard",
      path: "/dashboard",
      icon: <LayoutDashboard className="h-4 w-4" />,
    },
    {
      title: "Strategy Generator",
      path: "/strategy-generator",
      icon: <Code className="h-4 w-4" />,
    },
    {
      title: "Onboarding Files",
      path: "/onboarding-files",
      icon: <FileUp className="h-4 w-4" />,
    },
    {
      title: "Shop Configuration",
      path: "/shop-configuration",
      icon: <Settings className="h-4 w-4" />,
    },
  ];

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar />

      <div className="flex flex-col flex-1 w-full overflow-hidden">
        <Header />

        <main className="flex-1 overflow-y-auto bg-gray-50 p-4 md:p-6">
          <div className="max-w-7xl mx-auto">
            <Outlet />
          </div>
        </main>

        <Footer />
      </div>
    </div>
  );
}

export default MainLayout;
